module.exports = __webpack_public_path__ + "static/media/language_understand_video.58a77861.mp4";